import { setCorporateEmailDomains } from "resource-planner-model";
import { Middleware } from "redux";
import { AppState, INIT_APP } from "../redux/AppTypes";
import service from "./ApplicationConfigService";
import {
  ApplicationConfigAction as BaseAction,
  FETCH_APPLICATION_CONFIG as FETCH,
  LOAD_APPLICATION_CONFIG as LOAD,
  LoadApplicationConfigAction as LoadAction,
  PERSIST_APPLICATION_CONFIG as PERSIST,
} from "./ApplicationConfigTypes";

async function loadConfig(store: any) {
  const item = await service.fetch();
  setCorporateEmailDomains(item.corporateEmailDomains);
  const load: LoadAction = {
    type: LOAD,
    item,
  };
  store.dispatch(load);
  return item;
}

const initMiddleware: Middleware<{}, AppState> =
  (store) => (next) => async (action: BaseAction | { type: string }) => {
    if (action.type === INIT_APP) {
      await loadConfig(store).catch((): undefined => undefined);
    }
    return next(action);
  };

const fetchMiddleware: Middleware<{}, AppState> =
  (store) => (next) => async (action: BaseAction) => {
    const result = next(action);
    if (action.type === FETCH) {
      return loadConfig(store);
    }
    return result;
  };

const persistMiddleware: Middleware<{}, AppState> =
  (store) => (next) => async (action: BaseAction) => {
    const result = next(action);
    if (action.type === PERSIST) {
      const item = await service.persist(action.item);
      setCorporateEmailDomains(item.corporateEmailDomains);
      const load: LoadAction = {
        type: LOAD,
        item,
      };
      store.dispatch(load);
      return item;
    }
    return result;
  };

const middlewares = [initMiddleware, fetchMiddleware, persistMiddleware];
export default middlewares;
